import * as React from "react";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { EditIncomeWithdrawalsAction } from "./Actions/EditIncomeWithdrawalsAction";
import { IncomePaymentDetails } from "./Components/IncomePaymentDetails/IncomePaymentDetails";
import { Review } from "./Components/Review/Review";
import { EditIncomeWithdrawalsSteppersMap, productMap } from "./Resource/Contents";
import { EditIncomeWithdrawalsInstructionStore } from "./Stores/Variable";
import { DrawdownType } from "../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { IStepConfig } from "../../../../Shared/Process/Process/Process";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
interface IEditIncomeWithdrawalsWizardState extends IAccountContextWizardComponentState {
    extraInfo: any;
}
export class EditIncomeWithdrawalsWizard extends AccountContextWizardComponent<IEditIncomeWithdrawalsWizardState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(EditIncomeWithdrawalsInstructionStore, () => this.onInstructionStoreChange());
    }

    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: null,
        };
    }
    private onInstructionStoreChange() {
        const data = EditIncomeWithdrawalsInstructionStore.getData();
        this.setState({
            isLoading: false,
            data: data,
        });
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        EditIncomeWithdrawalsAction.getBankAccounts(hierarchyId, (result) => {
            this.setState({
                extraInfo: { AllBankAccounts: result, Drawdowntype: DrawdownType.Flexible },
                isLoading: false,
                //data: EditIncomeWithdrawalsInstructionStore.getData(),
            }); // Edit income have no drawdown type
        });
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);
        const { data } = this.state;
        const steppers: IStepConfig[] = [
            {
                title: EditIncomeWithdrawalsSteppersMap.incomePaymentDetails,
                url: Urls.get().EditIncomeWithdrawalsIncomePaymenDetails,
                path: Contents.URLMap.incomePayment,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },
                component: <IncomePaymentDetails {...this.getStepProps(0)} extraInfo={this.state.extraInfo} />,
            },

            {
                title: EditIncomeWithdrawalsSteppersMap.review,
                url: Urls.get().EditIncomeWithdrawalsReview,
                path: Contents.URLMap.review,
                onStepLeave: (from: any, to: any) => {
                    this.onStepperLeave(from, to);
                },
                component: <Review {...this.getStepProps(1)} extraInfo={this.state.extraInfo} />,
            },

            {
                title: EditIncomeWithdrawalsSteppersMap.confirm,
                url: Urls.get().EditIncomeWithdrawalsConfirmation,
                path: Contents.URLMap.confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={`We've sucessfully received your instruction to edit income payments for ${data?.ClientDetails?.PersonalDetails?.GivenName} ${data?.ClientDetails?.PersonalDetails?.FamilyName}.`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];

        this.stepperConfig = steppers;
    }

    setProcessProps() {
        const type = Number(getQueryParameters()["type"]);
        const { data } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "Edit income payments";
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: `${data?.ClientDetails?.PersonalDetails?.GivenName} ${data?.ClientDetails?.PersonalDetails?.SecondFamilyName}`,
            splitHeaderSub: this.state.clientAccount?.HeadClAccountId,
        };
        processProps.subTitle = productMap[type];
        return processProps;
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {
        if (!params["id"]) {params["id"] = this.state.data?.DrawdownIncomeAmendmentInstruction?.Id;}
        EditIncomeWithdrawalsAction.saveInstruction(this.state.data, (result) => {
            this.setState({ onPosting: false });
            if (result.length > 0) {
                this.setState({ errorMsg: result, isShowErrorMsg: true });
            } else {
                if (to == -1) {
                    this.onExit();
                } else {
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        });
    }
    onCancel() {
        this.onExit();
    }
    onExit() {
        const params = getQueryParameters();
        //TODO: navigate to customer dashboard
        // Navigator.navigateTo(Urls.get().main.ClientDashboard, {
        //     queryParamsObject: {
        //         hierarchyid: params["hierarchyid"],
        //     },
        //     scrollAfterNavigating: true,
        // });
    }
    onSubmit() {
        this.setState({ isSubmitting: true });

        EditIncomeWithdrawalsAction.submitInstruction(null, () =>
            this.setState({ active: false, isSubmitting: false })
        );
    }
}
